import { createReducer } from 'redux-act';
import * as actions from '../actions/scenario';
import moment from 'moment/moment';
import { parseAtValue } from '#app/helpers/dateFieldTransforms';

export const getDefaultAvatar = (): string => {
  return process.env.REACT_APP_API_URL + '/images/avatar/default.svg';
};

interface ScenarioState {
  avatar: string | undefined;
  data: Record<string, unknown>;
  formLoading: boolean;
  tutorial: boolean;
  demo: boolean;
  helperClose: () => void;
  helperGotoStep: () => void;
}

const initialState: ScenarioState = {
  avatar: getDefaultAvatar(),
  data: {
    id: null,
  },
  formLoading: true,
  tutorial: false,
  demo: false,
  helperClose: () => {},
  helperGotoStep: () => {},
};

const handleStartTutorial = (
  state: ScenarioState,
  data: { scenario?: { name?: string } }
): ScenarioState => {
  if (data) {
    const json = data.scenario;

    if (json && json.name) {
      switch (json.name) {
        case 'register':
          return {
            ...state,
            tutorial: true,
          };
        case 'demo':
          return {
            ...state,
            demo: true,
          };
      }
    }
  }

  return state;
};

const handleEndTutorial = (state: ScenarioState): ScenarioState => ({
  ...state,
  tutorial: false,
});

const handleStartDemo = (state: ScenarioState): ScenarioState => ({
  ...state,
  demo: true,
});

const handleEndDemo = (state: ScenarioState): ScenarioState => ({
  ...state,
  demo: false,
});

const bindHelperGotoFunc = (
  state: ScenarioState,
  func: (...args: unknown[]) => void
): ScenarioState => {
  if (typeof func === 'function') {
    return {
      ...state,
      helperGotoStep: func as () => void,
    };
  }
  return state;
};

const bindHelperCloseFunc = (
  state: ScenarioState,
  func: (...args: unknown[]) => void
): ScenarioState => {
  if (typeof func === 'function') {
    return {
      ...state,
      helperClose: func as () => void,
    };
  }
  return state;
};

const handleFormAvatar = (state: ScenarioState, data: { avatar: string }): ScenarioState => ({
  ...state,
  avatar: data.avatar,
});

const handleFormDataStatus = (state: ScenarioState, status: boolean): ScenarioState => ({
  ...state,
  formLoading: status,
});

const handleFormData = (state: ScenarioState, data: Record<string, unknown>): ScenarioState => {
  const form: Record<string, unknown> = {
    id: data.id,
    first_name: data.first_name,
    last_name: data.last_name,
    middle_name: data.middle_name,
    email: data.email,
    phone: data.phone,
    retired_age: data.retired_age,
    dead_age: data.dead_age,
    currency_id: data.currency_id,
    language_id: data.language_id,
    data: data.data,
    percent_positive: data.percent_positive,
    percent_neutral: data.percent_neutral,
    percent_negative: data.percent_negative,
    index_positive_income: data.index_positive_income,
    index_neutral_income: data.index_neutral_income,
    index_negative_income: data.index_negative_income,
    index_outcome: data.index_outcome,
    vk: data.vk,
    fb: data.fb,
    twit: data.twit,
    points: data.points,
  };

  const birthAtRaw = data['birth_at'] ?? data['birth_at'];
  if (birthAtRaw && typeof birthAtRaw === 'string' && birthAtRaw.length > 0) {
    const date = parseAtValue(birthAtRaw)!;
    form['birth_at'] = date.format('YYYY-MM-DD');
    form['birth_at_user'] = date.format('DD.MM.YYYY');
    form['birth_at'] = date.toDate();
  } else {
    form['birth_at'] = '';
    form['birth_at_user'] = '';
    form['birth_at'] = null;
  }

  const startEnterRaw = data['start_enter_at'] ?? data['start_enter_at'];
  if (startEnterRaw && typeof startEnterRaw === 'string' && startEnterRaw.length > 0) {
    const date = parseAtValue(startEnterRaw)!;
    form['start_enter_at'] = date.format('YYYY-MM-DD');
    form['start_enter_at_user'] = date.format('DD.MM.YYYY');
    form['start_enter_at'] = date.toDate();
  } else {
    form['start_enter_at'] = '';
    form['start_enter_at_user'] = '';
    form['start_enter_at'] = null;
  }

  const months = moment.months();

  months.map((item, key) => {
    if (key === data['career_start_month']) {
      (form as Record<string, unknown>).career_start_month = {};
      (form.career_start_month as Record<string, unknown>).id = key;
      (form.career_start_month as Record<string, unknown>).name = item;
    }
  });

  return {
    ...state,
    formLoading: false,
    avatar: data.avatar as string | undefined,
    data: form,
  };
};

export default createReducer<ScenarioState>(
  {
    [actions.handleFormData as any]: handleFormData,
    [actions.handleFormAvatar as any]: handleFormAvatar,
    [actions.handleFormDataStatus as any]: handleFormDataStatus,
    [actions.bindHelperGotoFunc as any]: bindHelperGotoFunc,
    [actions.bindHelperCloseFunc as any]: bindHelperCloseFunc,
    [actions.handleStartTutorial as any]: handleStartTutorial,
    [actions.handleEndTutorial as any]: handleEndTutorial,
    [actions.handleStartDemo as any]: handleStartDemo,
    [actions.handleEndDemo as any]: handleEndDemo,
  },
  initialState
);

////
// import {createReducer} from 'redux-act'
// import * as actions from '../actions/scenario'
// import moment from "moment/moment";

// export const getDefaultAvatar = () =>
// {
//   return process.env.REACT_APP_API_URL + '/images/avatar/default.svg';
// }

// let data = {
//   avatar: getDefaultAvatar(),
//   data: {
//     id: null
//   },
//   formLoading: true,
//   tutorial: false,
//   demo: false,
//   helperClose: () => {

//   },
//   helperGotoStep: () => {

//   }
// };

// const handleStartTutorial = (state, data) =>
// {
//   if (data)
//   {
//     let json = data.scenario;

//     if (json && json.name)
//     {
//       switch (json.name)
//       {
//         case 'register':
//           return {
//             ...state,
//             tutorial: true
//           }
//           break;
//         case 'demo':
//           return {
//             ...state,
//             demo: true
//           }
//           break;
//       }
//     }
//   }

//   return state;
// }

// const handleEndTutorial = (state) =>
// {
//   return {
//     ...state,
//     tutorial: false
//   }
// }

// const handleStartDemo = (state, data) =>
// {
//     return {
//       ...state,
//       demo: true
//     }
// }

// const handleEndDemo = (state) =>
// {
//   return {
//     ...state,
//     demo: false
//   }
// }

// const bindHelperGotoFunc = (state, func) => {
//   if(typeof func === 'function')
//   {
//     return {
//       ...state,
//       helperGotoStep: func
//     }
//   }else{
//     return state;
//   }
// };

// const bindHelperCloseFunc = (state, func) => {
//   if(typeof func === 'function')
//   {
//     return {
//       ...state,
//       helperClose: func
//     }
//   }else{
//     return state;
//   }
// };

// const handleFormAvatar = (state, data) => {
//   return {
//     ...state,
//     avatar: data.avatar
//   }
// };

// const handleFormDataStatus = (state, status) => {
//   return {
//     ...state,
//     formLoading: status
//   }
// };

// const handleFormData = (state, data) => {

//   let form = {
//     id: data.id,
//     first_name: data.first_name,
//     last_name: data.last_name,
//     middle_name: data.middle_name,
//     email: data.email,
//     phone: data.phone,
//     retired_age: data.retired_age,
//     dead_age: data.dead_age,
//     currency_id: data.currency_id,
//     language_id: data.language_id,
//     data: data.data,
//     percent_positive: data.percent_positive,
//     percent_neutral: data.percent_neutral,
//     percent_negative: data.percent_negative,
//     index_positive_income: data.index_positive_income,
//     index_neutral_income: data.index_neutral_income,
//     index_negative_income: data.index_negative_income,
//     index_outcome: data.index_outcome,
//     vk: data.vk,
//     fb: data.fb,
//     twit: data.twit,
//     points: data.points,
//   };

//   if (data['birth_at'] && typeof data['birth_at'] === 'string' && data['birth_at'].length > 0)
//   {
//     let date = moment(data['birth_at'], 'DD.MM.YYYY');
//     form['birth_at'] = date.format('YYYY-MM-DD');
//     form['birth_at_user'] = date.format('DD.MM.YYYY');
//     form['birth_at'] = date.toDate();
//   } else
//   {
//     form['birth_at'] = '';
//     form['birth_at_user'] = '';
//     form['birth_at'] = null;
//   }

//   if (data['start_enter_at'] && typeof data['start_enter_at'] === 'string' && data['start_enter_at'].length > 0)
//   {
//     let date = moment(data['start_enter_at'], 'DD.MM.YYYY');
//     form['start_enter_at'] = date.format('YYYY-MM-DD');
//     form['start_enter_at_user'] = date.format('DD.MM.YYYY');
//     form['start_enter_at'] = date.toDate();
//   } else {
//     form['start_enter_at'] = '';
//     form['start_enter_at_user'] = '';
//     form['start_enter_at'] = null;
//   }

//   let months = moment.months();

//   months.map((item, key) =>
//   {
//     if(key === data['career_start_month'])
//     {
//       form.career_start_month = {};
//       form.career_start_month.id = key;
//       form.career_start_month.name = item;
//     }
//   });

//   return {
//     ...state,
//     formLoading: false,
//     avatar: data.avatar,
//     data: form
//   }
// }

// const reducer = createReducer({
//   [actions.handleFormData]: handleFormData,
//   [actions.handleFormAvatar]: handleFormAvatar,
//   [actions.handleFormDataStatus]: handleFormDataStatus,
//   [actions.bindHelperGotoFunc]: bindHelperGotoFunc,
//   [actions.bindHelperCloseFunc]: bindHelperCloseFunc,
//   [actions.handleStartTutorial]: handleStartTutorial,
//   [actions.handleEndTutorial]: handleEndTutorial,
//   [actions.handleStartDemo]: handleStartDemo,
//   [actions.handleEndDemo]: handleEndDemo,
// }, data);

// export default reducer
